package com.mps.asc_app.data.user

data class MemberSummary(
    val uid: String,
    val displayName: String,
    val email: String,
    val createdAtEpochMillis: Long? = null,
    val memberNumber: String = "",
    val sports: List<String> = emptyList(),
    val status: UserStatus,
    val isAdmin: Boolean,
    val isTrainer: Boolean,
    val trainerAssignments: List<String>,
    val privacyConsentAccepted: Boolean,
)
